// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"2186db47","122":"c298831f","180":"d67c0f1b","283":"93c6684f","286":"fbb9a0e4","453":"1df3f97e","461":"f606e746","684":"5857cbe8","718":"a79e1b61","758":"8cf8c95f","854":"95b597fe"}[chunkId] + ".chunk.js";
};